import { createSelector } from 'redux-bundler';

export const selectOrganizationOptions = createSelector(
  'selectAllOrganizationIDs',
  'selectOrganizationsById',
  (allIDs, byId) =>
    allIDs.length
      ? allIDs.map((id) => ({ label: byId[id]?.name ?? '', value: id }))
      : [],
);

export const selectOrganizationSelectedOption = createSelector(
  'selectCurrentOrganizationId',
  'selectOrganizationsById',
  (id, byId) => ({
    label: byId[id]?.name ?? '',
    value: id,
  }),
);
